<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="item in customerTabs" :key="item.value" :label="item.label" :name="item.value">
      </el-tab-pane>
    </el-tabs>
    <component :customerData="customerData" :tagList="tagList" :is="activeName" :customerId="customerId" :customerType="customerType"></component>
  </div>
</template>
<script>
import accident from '../../components/accident/index.vue' // 事故
import enterpriseBasic from '../../components/enterpriseBasic/index.vue' // 企业基本信息
import enterpriseOrder from '../../components/enterpriseOrder/index.vue' // 个人订单
import license from '../../components/license/index.vue' // 个人证照
import maintenance from '../../components/maintenance/index.vue' // 维保
import personalBasic from '../../components/personalBasic/index.vue' // 个人基本信息
import personalOrder from '../../components/personalOrder/index.vue' // 个人订单
import violation from '../../components/violation/index.vue' // 违章
import customerDetail from '../../config'
// API接口引入
import { getCustomerDetail } from '@/api/company'
import { getCustomerDetailSensitive } from '@/api/domain/customers'
// 依赖项
import selectOption from '@/store/dict/selectOptionDict'
import { CUSTOMER_CONFIG, CUSTOMER_TYPE } from '../../../list/config'

// id：客户id ；customerType：1客户 2企业
const API_CONF = {
  [CUSTOMER_CONFIG[CUSTOMER_TYPE.person].value]: getCustomerDetailSensitive,
  [CUSTOMER_CONFIG[CUSTOMER_TYPE.company].value]: getCustomerDetail,
}

export default {
  name: 'customerDetail',
  props: ['tabName'],
  data() {
    const { customerTabs } = customerDetail.call(this)
    return {
      customerTabs,
      activeName: customerTabs[0] && customerTabs[0].value,
      customerData: {
        manager: {},
        vehicleManager: {},
      },
      tagList: [],
      customerId: '',
      customerType: '',
    }
  },
  components: {
    personalOrder,
    enterpriseOrder,
    maintenance,
    violation,
    personalBasic,
    enterpriseBasic,
    license,
    accident,
  },
  methods: {
    customerDetailInit() {
      const { customerType, id } = this.$route.query
      this.customerId = id
      this.customerType = customerType
      if (!id) return
      API_CONF[customerType]({ id }).then((res) => {
        const { data } = res
        this.customerData = Object.assign({}, data, data.individualCustomerVo, data.enterpriseCustomerVo)
        this.tagList = data[Number(customerType) === 1 ? 'individualCustomerVo' : 'enterpriseCustomerVo'].tagList
        const { customerData } = this
        customerData.networkDriverLicense = selectOption.isHaveList[customerData.networkDriverLicense]
        customerData.source = selectOption.customerSourceList[data.source]
        customerData.customerStateName = selectOption.accountStateDict[customerData.customerState]
        customerData.customerTypeName = selectOption.customertypeDict[customerData.customerType]
        customerData.taxType = selectOption.taxTypeList[customerData.taxType]
        const { emergencyList: emergencyContactList } = customerData
        if (Array.isArray(emergencyContactList) && emergencyContactList.length) {
          customerData.emergencyContactList = emergencyContactList
        } else {
          customerData.emergencyContactList = [{ emergencyContact: '', emergencyContactRelation: '', emergencyContactTel: '' }]
        }
        if (!customerData.manager) {
          customerData.manager = {
            avatar: '',
            userName: null,
            userMobile: null,
          }
        }
        if (!customerData.vehicleManager) {
          customerData.vehicleManager = {
            avatar: '',
            userName: null,
            userMobile: null,
          }
        }
        this.filterImage(customerData)
      })
    },
    // 图片数据格式化
    filterImage(data) {
      if (!data) return
      // 身份证-正面
      const idCardUrl = this.getEchoUploadFileData(data.idCardUrl)
      data.idCardUrl = idCardUrl[0]
      // 身份证-背面
      const idCardBackUrl = this.getEchoUploadFileData(data.idCardBackUrl)
      data.idCardBackUrl = idCardBackUrl[0]
      // 驾驶证-正面
      const driverLicenceUrl = this.getEchoUploadFileData(data?.driverLicenceUrl)
      data.driverLicenceUrl = driverLicenceUrl[0]
      // 驾驶证-背面
      const driverLicenceBackUrl = this.getEchoUploadFileData(data.driverLicenceBackUrl)
      data.driverLicenceBackUrl = driverLicenceBackUrl[0]
      // 网约车人证
      const hailingLicenceUrl = this.getEchoUploadFileData(data.hailingLicenceUrl)
      data.hailingLicenceUrl = hailingLicenceUrl[0]
      // 营业执照
      const businessLicenceUrl = this.getEchoUploadFileData(data.businessLicenceUrl)
      data.businessLicenceUrl = businessLicenceUrl[0]
      // 银行卡照片
      const bankPic = this.getEchoUploadFileData(data.bankPic)
      data.bankPic = bankPic[0]
      // 车管头像
      if (data.vehicleManager.avatar) {
        const carServicerPic = this.getEchoUploadFileData(data.vehicleManager.avatar)
        data.vehicleManager.avatar = carServicerPic[0]
      }
      // 司管头像
      if (data.manager.avatar) {
        const driverServicerPic = this.getEchoUploadFileData(data.manager.avatar)
        data.manager.avatar = driverServicerPic[0]
      }
    },
  },
  created() {
    if (this.tabName) this.activeName = this.tabName
    // 初始化客户详情
    this.customerDetailInit()
  },
}
</script>

<style lang="scss" scoped>
.orderId {
  color: #2e7eff;
  cursor: pointer;
}
.table-dropdown {
  .more-btn {
    margin-left: 12px;
  }

  .el-icon-arrow-down,
  .el-icon-arrow-up {
    font-size: 12px;
    margin-left: 3px;
  }
}
.table-dropdown-menu {
  .el-dropdown-menu__item {
    .el-button {
      color: #606266;
    }
  }
}
.leasecontract {
  ::v-deep .el-tabs__item {
    max-width: 140px;
    text-align: center;
  }

  .whole_contract_btn {
    &:nth-of-type(2) {
      color: #323233;
    }
  }

  .whole_contract_ex {
    margin-left: 8px;
  }

  .leasecontract_signing {
    margin: 16px 0;
  }
}
</style>
